$(document).ready(function () {
    $(".js_menu_toggle").on("click", function () {
        $(".nav_ham").toggleClass("open")
        $(".navbar_menu").toggleClass("active")
    })
});